import TabbarItem from "./TabbarItem";

export type TabId = "home" | "challenges" | "create" | "profile";

interface TabbarProps {
  activeTab: TabId;
  onTabChange: (tab: TabId) => void;
}

// Icons as inline SVG for better control
const HomeIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <polyline points="9 22 9 12 15 12 15 22" />
  </svg>
);

const ChallengesIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <polyline points="10 9 9 9 8 9" />
  </svg>
);

const CreateIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const ProfileIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

function Tabbar({ activeTab, onTabChange }: TabbarProps) {
  return (
    <nav className="tabbar">
      <TabbarItem
        icon={<HomeIcon />}
        label="Home"
        isActive={activeTab === "home"}
        onClick={() => onTabChange("home")}
      />
      <TabbarItem
        icon={<ChallengesIcon />}
        label="Challenges"
        isActive={activeTab === "challenges"}
        onClick={() => onTabChange("challenges")}
      />
      <TabbarItem
        icon={<CreateIcon />}
        label="Create"
        isActive={activeTab === "create"}
        onClick={() => onTabChange("create")}
      />
      <TabbarItem
        icon={<ProfileIcon />}
        label="Profile"
        isActive={activeTab === "profile"}
        onClick={() => onTabChange("profile")}
      />
    </nav>
  );
}

export default Tabbar;
